document.addEventListener("DOMContentLoaded", function () {
  // Product Grid Swiper configuration
  const productGridConfig = {
    slidesPerView: 2,
    grid: {
      rows: 2,
      fill: "row",
    },
    spaceBetween: 0,
    allowTouchMove: false,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        grid: {
          rows: 1,
        },
      },
    },
  };

  // Product Image Swiper configuration
  const productImageConfig = {
    loop: true,
    nested: true,
    //effect: 'fade',
    fadeEffect: {
      //crossFade: true
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  // Initialize all Swiper instances
  function initSwipers() {
    // Main Product Grid Swiper
    const productGridSwiper = new Swiper(
      ".finkid-products-swiper .swiper-container",
      productGridConfig
    );

    // Product Image Swipers
    const productImageSwipers = document.querySelectorAll(
      ".product-image-swiper"
    );

    productImageSwipers.forEach((element) => {
      new Swiper(element, productImageConfig);
    });
  }

  // Initialize on page load
  initSwipers();

  // Re-initialize on Shopify section loads/changes
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", initSwipers);
    document.addEventListener("shopify:section:select", initSwipers);
  }
});

// FINKID PRODUCT SLIDER
window.moveSlider = function (button, direction = 'next') {
  const wrapper = button.closest('[data-slider]');
  const container = wrapper?.querySelector('.simple-slider-container');
  if (!container) return;

  const scrollAmount = Math.round(window.innerWidth * 0.8);
  const amount = direction === 'next' ? scrollAmount : -scrollAmount;

  container.scrollBy({ left: amount, behavior: 'smooth' });
};
